import { Button, Modal } from '@simplywallst/ui-core';
import CrossSolid from '@simplywallst/ui-core/icons/CrossSolid';

import type { PortfolioAnalysis } from '../../../../hooks/usePortfolioAnalysis';
import { useNormalisedDiversification } from '../../hooks';

import { Chart } from '../Chart';

import { StyledGrid, StickyGrid, ChartWrapper } from './styled';

interface Props {
  diversification: NonNullable<PortfolioAnalysis['diversification']>;
  holdingsCount: number;
  onClose: () => void;
}

export const OversizedChartModal = ({
  diversification,
  holdingsCount,
  onClose,
}: Props) => {
  const data = useNormalisedDiversification({
    diversification,
  });
  return (
    <Modal isNaked={true} fullscreen={true}>
      <StyledGrid
        templateRows="max-content auto"
        data-cy-id="oversized-diversification-chart"
      >
        <StickyGrid justifyContent="end">
          <Button styleType="passiveLarge" onClick={onClose} aria-label="Close">
            <CrossSolid />
          </Button>
        </StickyGrid>
        <ChartWrapper>
          <Chart data={data} holdingsCount={holdingsCount} />
        </ChartWrapper>
      </StyledGrid>
    </Modal>
  );
};
